<template>
  <div>
    <!-- <el-row :gutter="15">
      <el-col :span="24"> -->
        <el-row :gutter="15">
          <el-col :span="14">
            <el-card style="margin-top: 15px">
              <el-row class="title_row">
                <el-col>
                  <span class="title_class">裁判功能</span>
                </el-col>
              </el-row>
              <div>
                <el-button type="primary" plain icon="el-icon-success" @click="showStuList(1)">登录情况</el-button>
                <el-button type="primary" plain icon="el-icon-link" @click="copy('rank')">大屏排行榜</el-button>
                <el-button type="success" plain @click="handleToScore()">前往考务管理</el-button>
              </div>
            </el-card>
          </el-col>
          <el-col :span="10">
            <!-- 筛选 -->
            <el-card style="margin-top: 15px">
              <el-row class="title_row">
                <el-col>
                  <span class="title_class">筛选<span class="tips">比赛进行中，请勿刷新页面</span></span>
                </el-col>
              </el-row>
              <el-form
                :model="queryForm"
                class="filter_Form"
                label-width="60px"
                ref="queryFormRef"
              >
                <el-row :gutter="20">
                  <el-col :span="10">
                    <el-form-item label="赛季" prop="season" style="margin-bottom: 0;">
                      <el-select
                        placeholder="请选择"
                        style="width: 100%"
                        v-model="queryForm.season"
                        @change="seasonChange"
                      >
                        <el-option
                          v-for="item in dict_season"
                          :key="item.dictValue"
                          :label="item.dictLabel"
                          :value="item.dictValue"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="10">
                    <el-form-item label="组别" prop="level" style="margin-bottom: 0;">
                      <el-select
                        placeholder="请选择类型"
                        style="width: 100%"
                        v-model="queryForm.level"
                        @change="levelChange"
                      >
                        <el-option
                          v-for="item in dict_group"
                          :key="item.dictCode"
                          :label="item.dictLabel"
                          :value="item.dictCode"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" >
                    <el-button type="primary" @click="getList" :icon="isLoading ? 'el-icon-loading' : ''">查询</el-button>
                  </el-col>
                </el-row>
              </el-form>
            </el-card>
          </el-col>
        </el-row>
        <!-- 列表 -->
        <el-card style="margin-top: 15px">
          <el-row class="title_row">
            <el-col :span="12">
              <span class="title_class">
                全球总决选{{ formatLevel(queryForm.level) }}
                <el-tag style="margin-left: 12px;" :type="matchEndType === 1 ? 'success' : matchEndType === 2 ? 'danger' : 'warning'">
                  {{ matchEndType === 1 ? '进行中' : matchEndType === 2 ? '已结束' : '未开始' }}
                </el-tag>
                <!-- <i class="refresh" :class="isLoading ? 'el-icon-loading' : 'el-icon-refresh'" @click="getList"></i> -->
                <!-- <span class="tips">比赛进行中，请勿刷新页面</span> -->
              </span>
            </el-col>
            <el-col :span="12" align="right">
              <!-- <span class="tips" v-if="show2Min">比赛剩余时间：</span>
              <span class="timer" v-if="show2Min" style="margin-left: 0;margin-right: 20px; color: #F56C6C;">{{ timeStr2 }}</span> -->
              <el-button type="danger" v-if="matchEndType === 1" @click="endFn" :disabled="matchEndType === 2">本场比赛结束</el-button>
              <!-- <el-button type="warning" @click="getExamQuestion()">获取考题</el-button> -->
              <el-button type="danger" plain @click="reset">重置比赛状态</el-button>
            </el-col>
          </el-row>
          <el-table
            header-cell-class-name="tableHeaderStyle"
            :data="dataList"
            :row-class-name="tableRowClassName"
            border
          >
            <el-table-column label="序号" type="index"></el-table-column>
            <el-table-column label="题目类型" prop="quizForm">
              <template slot-scope="scope">
                <el-tag size="mini" :effect="scope.row.quizForm === 1 ? 'dark' : 'light'">{{ scope.row.quizForm === 1 ? '例题' : '试题' }} </el-tag>
                <!-- <el-tag v-if="scope.row.isStandby" size="mini" type="warning" style="margin-left: 10px;">(备用)</el-tag> -->
              </template>
            </el-table-column>
            <!-- <el-table-column label="题号" prop="quizNumber" width="47"></el-table-column> -->
            <el-table-column label="题号" prop="quizNumber">
              <template slot-scope="scope">
                <el-tag v-if="scope.row.isStandby" size="mini" type="warning" style="margin-left: 10px;">备用{{ scope.row.quizNumber }}</el-tag>
                <div v-else>{{ scope.row.quizNumber }}</div>
              </template>
            </el-table-column>
            <el-table-column label="题型" prop="quizType">
              <template slot-scope="scope">
                <el-tag :type="scope.row.quizType === 1 ? 'warning' : scope.row.quizType === 2 ? 'success' : 'danger'">
                  {{ formatQuizType(scope.row.quizType) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="选项" prop="choice" :width="260">
              <template slot-scope="scope">
                <template v-if="scope.row.choiceType === 2">
                  <span class="choice-text" v-for="(font, index) of scope.row.choiceList" :key="index">{{ font }}</span>
                </template>
                <template v-else>
                  <div class="choice-img" v-for="(img, index) of scope.row.choiceList" :key="index">
                    <img :src="img" alt="">
                  </div>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="答案" prop="answer">
              <template slot-scope="scope">
                <div style="display: flex; align-items: center;">
                  <div v-for="(a, aIndex) of scope.row.answerList" :key="aIndex">
                    <div class="choice-img" v-if="a.length > 5">
                      <img :src="a" class=""/>
                    </div>
                    <span v-else class="choice-text">{{ a }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <!-- <el-table-column label="分数" prop="questionScore"></el-table-column> -->
            <el-table-column label="状态" prop="">
              <template slot-scope="scope">
                <el-tag v-if="matchEndType === 2" size="mini">已结束</el-tag>
                <el-tag size="mini" type="info" v-else-if="matchEndType !== 1 && matchEndType  !== 2">未作答</el-tag>
                <el-tag v-else-if="show2Min" size="mini">作答完成</el-tag>
                <template v-else>
                  <el-tag v-if="scope.row.usedIng" type="success">正在作答</el-tag>
                  <div class="timer" v-if="scope.row.usedIng">{{ timeStr }}</div>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="是否使用" width="100">
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.isUsed"
                  type="success"
                  size="mini"
                  >是</el-tag>
                <el-tag
                  v-else
                  type="info"
                  size="mini"
                  >否</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="是否作废" width="100">
              <template slot-scope="scope">
                <el-tag
                  v-if="scope.row.isDiscard"
                  type="danger"
                  size="mini"
                  >已作废</el-tag>
                <el-tag
                  v-else
                  type="info"
                  size="mini"
                  >否</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="170">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  :disabled="matchEndType === 2"
                  @click="startFn(scope)"
                >开始作答</el-button>
                      <el-button
                  type="danger"
                  size="mini"
                  :disabled="matchEndType === 2"
                  @click="cancellation(scope)"
                >作废</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div class="footer-tips">
            <!-- <span class="tips" v-if="show2Min">比赛剩余时间：</span>
            <span class="timer" v-if="show2Min" style="margin-left: 0;margin-right: 20px; color: #F56C6C;">{{ timeStr2 }}</span> -->
          </div>
        </el-card>
      <!-- </el-col>
    </el-row> -->
    <!-- 登录情况 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="80%">
      <span slot="title">
        {{ dialogTitle }}
        <i class="refresh" :class="loading ? 'el-icon-loading' : 'el-icon-refresh'" @click="showStuList(dialogType)"></i>
        <!-- <el-button type="primary" v-if="dialogType === 1" style="margin-left: 24px;" plain icon="el-icon-link" @click="copy('pad')">PAD端欢迎链接</el-button> -->
        <span v-if="dialogType === 1" style="margin-left: 20px;">
          <span class="dialog-title-tip">总人数：<b>{{ stuList.length }}</b>人</span>
          <span class="dialog-title-tip">已登录：<b>{{ loginNum }}</b>人</span>
          <span class="dialog-title-tip">未登录：<b>{{ logoutNum }}</b>人</span>
        </span>
      </span>
      <div class="set-info" v-if="dialogType === 3">
        <span>设置晋级到B轮人数：</span>
        <el-input-number v-model="topNum" :min="1" :max="stuList.length"></el-input-number>
        <el-button type="primary" style="margin-left:20px;" @click="setNextNumFn">确认</el-button>
      </div>
      <!-- 实时排名 -->
      <!-- <el-tabs type="border-card" @tab-click="handleClick" v-model="queryStuForm.drawOnePromote" v-if="dialogType === 2 && isGroup === 2">
        <el-tab-pane label="晋级名单" name="1"></el-tab-pane>
        <el-tab-pane label="淘汰名单" name="0"></el-tab-pane>
        <el-tab-pane label="未设置" name="-1"></el-tab-pane>
      </el-tabs> -->
      <el-table style="margin-top: 0;" v-if="dialogVisible"
        header-cell-class-name="tableHeaderStyle"
        :data="stuList"
        :row-class-name="tableRowClassName"
        border
      >
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="赛季" prop="season"></el-table-column>
        <el-table-column label="地区" prop="nationalityType">
          <template slot-scope="scope">
            <el-tag :type="scope.row.nationalityType === 'domestic' ? 'success' : scope.row.nationalityType === 'overseas' ? 'primary' : 'info'" effect="dark" size="small">
              {{ scope.row.nationalityType === 'domestic' ? '国内' : scope.row.nationalityType === 'overseas' ? '海外' : '未知' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="姓名" prop="userName">
          <template slot-scope="scope">
            <span class="num num1">{{ scope.row.userName }}</span>
          </template>
        </el-table-column>
        <el-table-column label="比赛号码牌" prop="matchNum">
          <template slot-scope="scope">
            <span class="num num1">{{ addZero(scope.row.matchNum) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="抽签顺序号" prop="raceNumber">
          <template slot-scope="scope">
            <span class="num">{{ addZero(scope.row.raceNumber) }}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="排名" prop="drawOneRank" v-if="dialogType === 2 && isGroup === 2">
          <template slot-scope="scope">
            <div class="rank-index">{{ scope.row.drawOneRank }}</div>
          </template>
        </el-table-column>
        <el-table-column label="分数" prop="roundOne" v-if="dialogType === 2 || dialogType === 3"></el-table-column>
        <el-table-column label="晋级状态" prop="drawOnePromote" v-if="dialogType === 2 && isGroup === 2">
          <template slot-scope="scope">
            <!-- <el-tag size="mini" :type="scope.row.drawOnePromote === 1 ? 'success' : scope.row.drawOnePromote === 0 ? 'danger' : ''">
              {{ scope.row.drawOnePromote === 1 ? '晋级' : scope.row.drawOnePromote === 0 ? '淘汰' : '未设置' }}
            </el-tag> -->
            <el-select v-model="scope.row.drawOnePromote" @change="promoteChange(scope.row)" size="small" :class="'promote' + scope.row.drawOnePromote">
              <el-option
                v-for="item in pList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="学校" prop="schoolName"></el-table-column>
        <el-table-column label="手机号" prop="phone"></el-table-column>
        <el-table-column
          label="组别"
          prop="enrollmentLevel"
          :formatter="levelFormatter"
        ></el-table-column>
        <!-- <el-table-column
          label="年级"
          prop="grade"
          :formatter="gradeFormatter"
        ></el-table-column> -->
        <el-table-column label="登录状态" prop="loginState" v-if="dialogType === 1">
          <template slot-scope="scope">
            <el-tag :type="scope.row.loginState === 1 ? 'success' : 'danger'">
              {{ scope.row.loginState === 1 ? '已登录' : '未登录' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" v-if="dialogType === 2">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="showDetail(scope.row)">答题详情</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
// import { queryDistrictPage } from '@/http/api'

export default {
  props: {
    season: {
      type: String
    },
    level: {
      type: Number
    }
  },
  data () {
    return {
      dict_group: this.$userInfo.dict_group(), // 组别下拉列表
      dict_grade: this.$userInfo.getGradeData(),
      examRoomId: '',
      examRooms: [], // 考场下拉列表
      dict_season: this.$userInfo.getDataList(this, 't_season').then(value => { this.dict_season = value }), // 赛季下拉列表
      dict_matchType: [], // 赛程下拉列表
      examRoomInfo: {}, // 考场信息
      queryForm: {
        activityType: this.$chnEngStatusCode.activityType,
        season: this.season,
        level: this.level,
        raceSchedule: '4'
      },
      queryStuForm: {
        activityType: this.$chnEngStatusCode.activityType,
        season: this.$chnEngStatusCode.defaultSeason,
        // raceSchedule: this.$chnEngStatusCode.raceScheduleFinal,
        isGroup: Number(this.$route.query.group)
        // drawOnePromote: '1' // 1:晋级 0:未晋级 -1:未设置
      },
      isGroup: Number(this.$route.query.group),
      dataList: [],
      quizTypeList: ['题型A', '题型B', '题型C'],
      matchEndType: 0,
      isLoading: false,
      timer: null,
      timeStr: '00:00',
      lastQuiz: false, // 标记是否最后一题，最后一题倒计时结束后，开始2min倒计时
      timer2: null,
      timeStr2: '00:00',
      show2Min: false,
      dialogType: 0,
      dialogVisible: false,
      dialogTitle: '',
      loading: false,
      loginNum: 0,
      logoutNum: 0,
      quizId: '',
      stuList: []
    }
  },
  created () {
  },
  methods: {
    handleToScore () {
      this.$router.push(`/examination_Management/final_answer?scheduleFlag=NATIONAL_FINALS&season=${this.queryForm.season}&level=${this.queryForm.level}&round=4`)
    },
    tableRowClassName ({ row }) {
      if (row.isDiscard) {
        return 'discarded'
      }
      if (row.isStandby) {
        return 'standby'
      }
      if (row.usedIng) {
        return 'usedIng'
      }
      return ''
    },
    formatLevel (level) {
      console.log(level)
      return level === 1 ? '-小初组（G1-G2）' : level === 2 ? '-小中组（G3-G4）' : level === 3 ? '-小高组（G5-G6）' : level === 4 ? '-初中组（G7-G9）' : ''
    },
    seasonChange () {
      this.getList()
      this.$emit('seasonChange', this.queryForm.season)
    },
    levelChange () {
      this.getList()
      this.$emit('levelChange', this.queryForm.level)
    },
    showStuList (type, init = true) { // 1-登录情况 2-实时排名 3-设置晋级人数
      this.loading = true
      this.dialogTitle = type === 1 ? '登录情况' : type === 2 ? '实时排名' : '设置晋级人数'
      this.dialogType = type
      // this.queryStuForm.activityType = this.queryForm.activityType
      this.queryStuForm.season = this.queryForm.season
      this.getStuList(type)
    },
    getStuList (type) {
      this.$http.get('/nationalResurrectionSign/signList', { params: { ...this.queryStuForm, ...{ level: this.queryForm.level, pageNum: 1, pageSize: 100000 } } }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.stuList = res.data.list
          if (this.dialogType === 1) {
            this.loginNum = res.data.list.filter(item => item.loginState === 1).length
            this.logoutNum = res.data.list.filter(item => item.loginState !== 1).length
          }
          this.dialogVisible = true
          console.log(this.stuList)
          if (type === 3) {
            // this.topNum = this.stuList.length
            this.topNum = 10
          }
        }
      })
    },
    getStatus () {
      this.$http.get('national/getProgress', { params: { season: this.queryForm.season, level: this.queryForm.level, quizId: this.quizId } }).then(res => {
        if (res.code === 200) {
          this.matchEndType = res.data ? res.data.matchEndType : 0
        }
      })
    },
    getList () {
      this.isLoading = true
      // form 1小组赛第一轮 2复活赛第一轮
      this.$http.get('/national/getQuestionByLevel', { params: { season: this.queryForm.season, level: this.queryForm.level, raceSchedule: 4, form: 2 } }).then(res => {
        if (res.code === 200) {
          this.dataList = res.data
          this.quizId = res.data[0].quizId
          this.getStatus()
          this.dataList.forEach(item => {
            // 选项
            if (item.choice.includes('http')) {
              item.choiceType = 1
            } else {
              item.choiceType = 2
            }
            item.choiceList = item.choice.split(',')
            // 答案
            item.answerList = item.answer.split(',')
          })
          this.currentIndex = this.dataList.findIndex(item => item.usedIng)
        }
        this.isLoading = false
      }).catch(() => {
        this.isLoading = false
      })
    },
    startFn (scope) {
      this.show2Min = false
      this.stop2MinCountdown()
      this.lastQuiz = scope.$index === this.dataList.length - 1
      this.stopCountdown()
      // console.log(scope.$index)
      const data = {
        // examinationId: this.examRoomId,
        season: this.queryForm.season,
        level: this.queryForm.level,
        matchEndType: 1, // "比赛结束状态 1:比赛中 2:已结束"
        index: scope.$index + 1,
        questionId: scope.row.id,
        quizId: this.quizId
      }
      this.$http.post('national/setProgress', data).then(res => {
        if (res.code === 200) {
          this.getList()
          const quizTime = Math.floor((res.data.endTime - new Date().getTime()) / 1000)
          this.timeStr = this.$xcUtils.sec2time(quizTime)
          if (quizTime > 0) {
            this.startCountdown(quizTime)
          }
        }
      })
    },

    endFn () {
      this.$confirm('强制交卷，结束本场比赛', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.stopCountdown()
        const data = {
          // examinationId: this.examRoomId,
          matchEndType: 2,
          season: this.queryForm.season,
          level: this.queryForm.level,
          quizId: this.quizId
        }
        this.$http.post('national/setProgress', data).then(res => {
          if (res.code === 200) {
            this.getStatus()
            this.$message.success('本场比赛结束')
            this.show2Min = false
            this.lastQuiz = false
            this.stopCountdown()
            this.stop2MinCountdown()
          }
        })
      }).catch(() => {
      })
    },
    reset () {
      this.$confirm('将比赛状态重置为“未开始”，请谨慎操作', '确认重置？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.stopCountdown()
        const data = {
          // examinationId: this.examRoomId,
          matchEndType: 0,
          index: null,
          questionId: null,
          season: this.queryForm.season,
          level: this.queryForm.level,
          quizId: this.quizId
        }
        this.$http.post('national/setProgress', data).then(res => {
          if (res.code === 200) {
            this.getList()
            this.$message.success('已重置')
            this.show2Min = false
            this.lastQuiz = false
            this.stopCountdown()
            this.stop2MinCountdown()
          }
        })
      }).catch(() => {
      })
    },
    startCountdown (quizTime) {
      this.timer = setInterval(() => {
        quizTime--
        console.log(quizTime)
        if (quizTime > 0) {
          this.timeStr = this.$xcUtils.sec2time(quizTime)
        } else {
          this.timeStr = '00:00'
          this.stopCountdown()
          if (this.lastQuiz) {
            this.show2Min = true
            this.timeStr2 = this.$xcUtils.sec2time(120)
            this.start2MinCountdown()
          }
        }
      }, 1000)
    },
    stopCountdown () {
      clearInterval(this.timer)
      this.timer = null
    },

    start2MinCountdown () {
      let quizTime = 120
      this.timer2 = setInterval(() => {
        quizTime--
        if (quizTime > 0) {
          this.timeStr2 = this.$xcUtils.sec2time(quizTime)
        } else {
          this.timeStr2 = '00:00'
          this.stop2MinCountdown()
        }
      }, 1000)
    },
    stop2MinCountdown () {
      clearInterval(this.timer2)
      this.timer2 = null
    },
    formatQuizType (quizType) {
      return quizType ? this.quizTypeList[quizType - 1] : ''
    },
    addZero (num) {
      return this.$xcUtils.addZero(num)
    },
    gradeFormatter (data) {
      return data.grade ? this.dict_grade.find(item => item.dictCode === data.grade).dictLabel : '--'
    },
    levelFormatter (data) {
      return data.level ? this.dict_group.find(item => item.dictCode === data.level).dictLabel : '--'
    },
    copy (str, type = 0) {
      var input = document.createElement('input') // 创建input标签
      var loc = window.location.origin
      const query = {
        activityType: this.queryForm.activityType,
        season: this.queryForm.season,
        group: this.isGroup,
        raceSchedule: this.queryForm.raceSchedule,
        phase: 1,
        level: this.queryForm.level,
        form: 2, // 复活赛传2
        quizId: this.quizId
      }
      console.log(query)
      input.value = `${loc}/#/${str}Final3round2?${this.$xcUtils.serialize(query)}` // 将input的值设置为需要复制的内容

      document.body.appendChild(input) // 添加input标签
      input.select() // 选中input标签
      document.execCommand('copy') // 执行复制
      this.$message.success('复制成功') // 成功提示信息
      document.body.removeChild(input) // 移除input标签
    },
    cancellation (scope) {
      console.log(scope)
      this.$confirm('是否确认作废该题目？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          // examinationId: this.examRoomId,
          matchEndType: 3,
          index: scope.$index + 1,
          questionId: scope.row.id,
          season: this.queryForm.season,
          level: this.queryForm.level,
          quizId: this.quizId
        }
        this.$http.post('national/setProgress', data).then(res => {
          if (res.code === 200) {
            this.stopCountdown()
            this.$message.success('作废成功')
            this.getList()
          }
        })
      }).catch(() => {
        // 用户取消操作
      })
    },

    beforeDestroy () {
      this.stopCountdown()
      this.stop2MinCountdown()
    }
  }
}
</script>
<style lang="less" scoped>
.choice-text{
  display: block;
  float: left;
  min-width: 20px;
  height: 24px;
  text-align: center;
  line-height: 24px;
  margin: 4px;
  border: 1px solid #409EFF;
  background-color: #fff;
  border-radius: 4px;
  font-size: 14px;
  color: #000;
  padding-left: 2px;
  padding-right: 2px;
}
.choice-img{
  width: 32px;
  height: 32px;
  padding-top: 1px;
  margin-right: 8px;
  border: 1px solid #409EFF;
  border-radius: 4px;
  text-align: center;
  display: inline-block;
  img{
    height: 28px;
    width: auto;
  }
}
::v-deep .el-table .usedIng {
    background: #e6f3ff;
}
::v-deep .el-table .discarded {
    background: #fde2e2;
}
::v-deep .el-table .standby {
    background: #f7e7d3;
}
.refresh{
  color: #409EFF;
  cursor: pointer;
  margin-left: 12px;
}
.timer{
  font-size: 16px;
  font-weight: bold;
  margin-left: 12px;
  color: #67c23a;
}
.tips{
  font-size: 12px;
  color: #606266;
  margin-left: 12px;
}
.footer-tips{
  text-align: center;
  margin-top: 20px;
  height: 30px;
}
.dialog-title-tip{
  font-size: 14px;
  font-weight: 400;
  margin-right: 14px;
  color: #606266;
  b{
    font-size: 16px;
    color: #409EFF;
  }
}
</style>
